import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Footer from "./components/Shared/Footer/Footer";
import RequireAuth from "./components/Shared/RequireAuth";
import Package from "./components/HomePage/Package";
import PaymentPending from "./Pages/Buyer/PaymentPending";
import { Toaster } from "react-hot-toast";
import PayNow from "./Pages/Buyer/PayNow";
import ResetPassword from "./Pages/ResetPassword";
import Contact from "./components/HomePage/Contact";
import About from "./Pages/About";
import ErrorPage from "./Pages/ErrorPage";
import SupportMessages from "./Pages/Admin/SupportMessages/SupportMessages";
import BuyerSupport from "./Pages/Seller/SupportMessage/BuyerSupport";
import DashboardLayout from "./components/AiHomePage/Dashboard/DashboardLayout";
import DashboardHome from "./components/AiHomePage/Dashboard/DashboardHome";
import OrdersList from "./components/AiHomePage/Dashboard/OrdersList";
import Packages from "./components/Admin/Packages";
import AdminDashboardLayout from "./components/AiHomePage/Dashboard/AdminDashBoard/AdminDashboardLayout";
import AdminDashboardHome from "./components/AiHomePage/Dashboard/AdminDashBoard/AdminDashboardHome";
import ManageUsers from "./components/AiHomePage/Dashboard/AdminDashBoard/ManageUsers";
import SettingsHome from "./components/Admin/Settings/SettingsHome";
import SubscriptionHistory from "./components/AiHomePage/Dashboard/SubscriptionHistory";
import AdminAuth from "./Pages/Seller/AdminAuth";
import SelectPackage from "./components/AiHomePage/SelectPackage";
import ItemsPakage from "./components/HomePage/ItemsPakage";
import ItemPayNow from "./Pages/Buyer/ItemPayNow";
import ItemsOrders from "./Pages/Admin/ItemsOrders";
import ItemsPaymentPending from "./Pages/Buyer/ItemsPaymentPending";
import PackagePaymentPending from "./Pages/Buyer/PackagePaymentPending";
import UserProfileUpdate from "./components/Admin/Settings/AccountSettings";
import BuyerCreateSupportTicket from "./Pages/Seller/SupportMessage/BuyerCreateSupportTicket";
import NavBar from "./components/YouTubeThumbnailHome/NavBar";
import ProductDescriptionGenerator from "./components/YouTubeThumbnailHome/ProductDescriptionGenerator";
import AllToolsList from "./components/Shared/AllToolsList/AllToolsList";
import ColdEmailGenerate from "./components/Shared/AllToolsList/ColdEmailGenerate";
import SocialMediaPostGenerate from "./components/Shared/AllToolsList/SocialMediaPostGenerate";
import SocialTagsGenerator from "./components/Shared/AllToolsList/SocialTagsGenerator";
import ArticleRewriter from "./components/Shared/AllToolsList/ArticleRewriter";
import ParagraphWriting from "./components/Shared/AllToolsList/ParagraphWriting";
import YouTubeGenerator from "./components/Shared/AllToolsList/YouTubeGenerator";
import VideoScriptGenerator from "./components/Shared/AllToolsList/VideoScriptGenerator";
import MetaGenerator from "./components/Shared/AllToolsList/MetaGenerator";
import TopicResearch from "./components/Shared/AllToolsList/Youtube/Tools/TopicResearch";
import YoutubeScriptGenerator from "./components/Shared/AllToolsList/Youtube/Tools/YoutubeScriptGenerator";
import FullYoutubeScriptGenerator from "./components/Shared/AllToolsList/Youtube/Tools/FullYoutubeScriptGenerator";
import YoutubeTitleTagsGenerator from "./components/Shared/AllToolsList/Youtube/Tools/YoutubeTitleTagsGenerator";
import ScriptSummaryGenerator from "./components/Shared/AllToolsList/Youtube/Tools/ScriptSummaryGenerator";
import YoutubeTranscriptGenerator from "./components/Shared/AllToolsList/Youtube/Tools/YoutubeTranscriptGenerator";
import YoutubeThumbnailGenerator from "./components/Shared/AllToolsList/Youtube/Tools/YoutubeThumbnailGenerator";
import TextToVoiceoverGenerator from "./components/Shared/AllToolsList/Youtube/Tools/TextToVoiceoverGenerator";
import YoutubeCommunityPostGenerator from "./components/Shared/AllToolsList/Youtube/Tools/YoutubeCommunityPostGenerator";
import DocumentaryScriptGenerator from "./components/Shared/AllToolsList/Youtube/Tools/DocumentaryScriptGenerator";
import YoutubeThumbnailDownloader from "./components/Shared/AllToolsList/Youtube/Tools/YoutubeThumbnailDownloader";
import HookGenerator from "./components/Shared/AllToolsList/Youtube/Tools/HookGenerator";
import AllInYouTube from "./components/Shared/AllToolsList/AllInYouTube";
import ThankYou from "./Pages/Buyer/ThankYou";


function App() {
  const location = useLocation();

  // Define paths where you don't want the NavBar and Footer
  const hideNavAndFooter =
    location.pathname !== "/login" &&
    location.pathname !== "/register" &&
    location.pathname !== "/reset-password" &&
    location.pathname !== "/about" &&
    location.pathname !== "/contact";
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <div className="">
      <Toaster />
      {/* {!hideNavAndFooter && <NavBar />} */}

      <Routes>
        <Route path="*" element={<ErrorPage />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/reset-password" element={<ResetPassword />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/buy/:id"element={ <RequireAuth><Package /></RequireAuth>}></Route>
        <Route path="/item-buy/:id" element={ <RequireAuth><ItemsPakage/></RequireAuth>}></Route>
        <Route path="/pay-now/:id" element={<RequireAuth><PayNow /></RequireAuth>}></Route>
       
        <Route path="/thank-you/:id" element={<RequireAuth><ThankYou /></RequireAuth>}></Route>
        <Route path="/item-pay-now/:id"element={<RequireAuth><ItemPayNow /></RequireAuth>}></Route>

        {/* Protected user routes */}
        <Route path="/" element={<RequireAuth><DashboardLayout /></RequireAuth>} >
          <Route index element={<AllToolsList />} />
          <Route path="dashboard" element={<DashboardHome />} />
          <Route path="orders" element={<OrdersList />} />
          <Route path="select-package" element={<SelectPackage />} />
          <Route path="create-support" element={<BuyerCreateSupportTicket />} />
          <Route path="support" element={<BuyerSupport />} />
          
          <Route path="pending-payment" element={<PaymentPending />} />
          <Route path="item-pending-payment" element={<ItemsPaymentPending />} />
          <Route path="package-pending-payment" element={<PackagePaymentPending />} />
          <Route path="subscription-history" element={<SubscriptionHistory />} />
          {/* yt  */}
          <Route path="hook-generate" element={<HookGenerator />} />
          <Route path="topic-research" element={<TopicResearch />} />
          <Route path="script-outline" element={<YoutubeScriptGenerator />} />
          <Route path="script-generate" element={<FullYoutubeScriptGenerator />} />
          <Route path="metadata-generator" element={<YoutubeTitleTagsGenerator />} />
          <Route path="script-summarizer" element={<ScriptSummaryGenerator />} />
          <Route path="documentary-script-generator" element={<DocumentaryScriptGenerator />} />
          <Route path="community-post-generator" element={<YoutubeCommunityPostGenerator />} />
          <Route path="thumbnail-generator" element={<YoutubeThumbnailGenerator />} />
          <Route path="text-to-voiceover" element={<TextToVoiceoverGenerator />} />
          <Route path="yt-thumbnail-downloader" element={<YoutubeThumbnailDownloader />} />
          <Route path="all-in-youtube" element={<AllInYouTube />} />
       
          {/* text based all tools list */}
          <Route path="seo-friendly-blog-article" element={<HookGenerator />} />
          <Route path="cold-email-generate" element={<ColdEmailGenerate />} />
          <Route path="social-media-post-generate" element={<SocialMediaPostGenerate />} />
          <Route path="youtube-post-generate" element={<YouTubeGenerator />} />
          <Route path="generate-product-description" element={<ProductDescriptionGenerator />} />
          <Route path="article-rewriter" element={<ArticleRewriter />} />
          <Route path="video-script-generator" element={<VideoScriptGenerator />} />
          <Route path="paragraph-writing" element={<ParagraphWriting />} />
          <Route path="social-tags-generator" element={<SocialTagsGenerator />} />
          <Route path="meta-generator" element={<MetaGenerator />} />
          
        </Route>

        {/* Protected admin routes */}
        <Route path="/admin" element={<RequireAuth><AdminAuth><AdminDashboardLayout /></AdminAuth></RequireAuth>}>
          <Route path="dashboard" element={<AdminDashboardHome />} />
          <Route path="orders" element={<OrdersList />} />
          <Route path="items-orders" element={<ItemsOrders />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="support-messages" element={<SupportMessages />} />
          <Route path="settings" element={<SettingsHome />} />
          <Route path="packages" element={<Packages />} />
        </Route>

        <Route path="/update-profile" element={<UserProfileUpdate />}></Route>
      </Routes>
      {/* {!hideNavAndFooter && <Footer />} */}
    </div>
  );
}

export default App;
